import { Batch } from '@clearkit/icons';
import { CKButton } from 'clearkit';
import { Link } from 'react-router-dom';

import { HomeNextStep } from '../HomeNextStep';

export const StepDataMapping = () => (
  <HomeNextStep>
    <HomeNextStep.Heading>
      Add data mappings and enable CRM enrichment
    </HomeNextStep.Heading>
    <HomeNextStep.Description>
      Map Clearbit data to fields in your CRM, and Clearbit will do the work to
      fill in the blanks and keep your data fresh.
    </HomeNextStep.Description>
    <HomeNextStep.Footer>
      <CKButton
        as={Link}
        leftIcon={<Batch />}
        to="/integrations"
        variant="simple"
        variantColor="blue"
      >
        Set up Enrichment
      </CKButton>
      {/**
       * @todo add URL
       * */}
      <CKButton href="/" variant="tertiary" variantColor="blue">
        Learn more
      </CKButton>
    </HomeNextStep.Footer>
  </HomeNextStep>
);
